import React from "react";

const Spinner = () => {
  const loaderStyle = {
    width: "15px", // Smaller circle size
    aspectRatio: "1",
    display: "grid",
    border: "2px solid transparent",
    borderRadius: "50%",
    borderColor: "var(--primary-color) transparent", // Using var(--primary-color)
    animation: "spin 1s infinite linear",
  };

  const beforeAfterStyle = {
    content: '""',
    gridArea: "1/1",
    margin: "2px",
    border: "2px solid transparent",
    borderRadius: "50%",
  };

  const beforeStyle = {
    ...beforeAfterStyle,
    borderColor: "var(--add-color) transparent", // Using var(--add-color)
    animation: "spin 0.5s infinite reverse linear",
  };

  const afterStyle = {
    ...beforeAfterStyle,
    margin: "4px", // Adjusted for smaller size
    borderColor: "var(--add-color) transparent", // Using var(--primary-color)
    animation: "spin 1.5s infinite linear",
  };

  return (
    <div style={loaderStyle}>
      <style>
        {`
          @keyframes spin {
            100% { transform: rotate(1turn); }
          }
        `}
      </style>
      <div style={beforeStyle}></div>
      <div style={afterStyle}></div>
    </div>
  );
};

const CenteredSpinner = () => {
  const containerStyle = {
    display: "flex",
    justifyContent: "center", // Horizontal centering
    alignItems: "center", // Vertical centering
    height: "100vh", // Full viewport height
    width: "100vw", // Full viewport width
    position: "fixed", // Keeps it fixed on the page
    top: 0,
    left: 0,
    zIndex: 9999, // Ensure it's on top
  };

  const circularBoxStyle = {
    width: "40px", // Outer circle size
    height: "40px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%", // Circular shape
    backgroundColor: "white", // Match page background or desired color
    //boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)", // Add shadow
  };

  return (
    <div style={containerStyle}>
      <div style={circularBoxStyle}>
        <Spinner />
      </div>
    </div>
  );
};

export default CenteredSpinner;
